import { useContext } from "react";
import { BaseInputV2AdornmentContext } from "./BaseInputV2AdornmentContext.tsx";

export const useBaseInputV2AdornmentContext = () => {
  const context = useContext(BaseInputV2AdornmentContext);
  if (!context) {
    throw new Error(
      "useBaseInputV2AdornmentContext must be used within BaseInputV2AdornmentContext.Provider",
    );
  }
  return context;
};
